import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'categoryHeader',
  'sectionTitle',
  'sectionDetails',
  'sectionDate',
  'enrichedData',
  'enrichedDataLabel',
  'enrichedDataValue',
  'enrichedDataLink',
  'gridBox',
  'chip',
  'percentageContainer',
  'percentageBox',
  'percentageBoxFilled',
]);

export const Resume = helpers.defineMultiStyleConfig({
  baseStyle: {
    categoryHeader: {
      width: '100%',
      borderBottom: '1px solid',
      borderBottomColor: 'var(--resume-heading-border, #2D426A)',
      backgroundColor: 'var(--resume-surface, #FFFFFF)',
      fontWeight: '600',
      fontSize: '16px',
      textTransform: 'uppercase',
      height: '24px',
    },
    sectionTitle: {
      color: 'var(--resume-text, #2D426A)',
      fontSize: '14px',
      fontWeight: '600',
    },
    sectionDetails: {
      color: 'var(--resume-text, #2D426A)',
      fontSize: '12px',
    },
    sectionDate: {
      opacity: '70%',
      color: 'var(--resume-text, #2D426A)',
      fontSize: '12px',
    },
    enrichedDataLabel: {
      color: 'var(--resume-text, #2D426A)',
      fontSize: '10px',
      fontWeight: '600',
      width: '100px',
      minWidth: '100px',
    },
    enrichedDataValue: {
      color: 'var(--resume-text, #2D426A)',
      opacity: '70%',
      fontSize: '10px',
      flex: 1,
    },
    enrichedDataLink: {
      color: 'var(--resume-link, #35ABDD)',
      fontSize: '10px',
      fontWeight: '600',
      textDecoration: 'underline',
    },
    enrichedData: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '4px',
    },
    percentageContainer: {
      display: 'flex',
      gap: '2px',
    },
    percentageBox: {
      height: '8px',
      width: '8px',
      borderRadius: '1px',
      backgroundColor: 'var(--resume-meter-empty, #CBD5E0)',
    },
    percentageBoxFilled: {
      height: '8px',
      width: '8px',
      borderRadius: '1px',
      backgroundColor: 'var(--resume-meter-filled, #35ABDD)',
    },
    gridBox: {
      backgroundColor: 'var(--resume-surface, #FFFFFF)',
      p: '10px 20px',
    },
    viewMoreButton: {
      color: 'ligtBlue.500',
    },
    divider: {
      height: '1px',
      borderBottom: '1px solid',
      borderBottomColor: 'var(--resume-divider, #CBD5E0)',
      borderBottomStyle: 'dashed',
    },
    dividerBox: {
      p: '10px 20px',
      backgroundColor: 'var(--resume-surface, #FFFFFF)',
    },
    chip: {
      borderRadius: 'full',
      fontSize: '10px',
      textTransform: 'uppercase',
      fontWeight: '600',
      padding: '0px 8px',
      width: 'fit-content',
    },
    placeholderBox: {
      bg: 'var(--resume-surface, #FFFFFF)',
    },
  },
  sizes: {
    sm: {},
    md: {},
  },
  variants: {
    resume: {
      categoryHeader: {},
    },
    pdf: {
      enrichedDataLabel: {},
      chip: {},
      categoryHeader: {
        backgroundColor: 'transparent',
      },
      sectionTitle: {},
      enrichedDataLink: {},
    },
  },
  defaultProps: {
    size: 'sm',
    variant: 'resume',
  },
});
